/* @flow */
// typecheck: ignore file
import React from 'react';
import NavItem from 'components/NavItem.jsx';

import './styles/AdminSchoolNav.scss';

type Props = {
  schoolId: number,
};

function AdminSchoolNav(props: Props) {
  return (
    <ul className="AdminSchoolNav">
      <NavItem to={'/admin/schools/' + props.schoolId + '/information/people'}>
        People
      </NavItem>
      <NavItem to={'/admin/schools/' + props.schoolId + '/information/classes'}>
        Classes
      </NavItem>
    </ul>
  );
}

export default AdminSchoolNav;



// WEBPACK FOOTER //
// ./src/admin/components/AdminSchoolNav.jsx